import Appointment2 from '@/components/Appointment2';
import Banner from '@/components/Banner2';
import Features from '@/components/Features';
import { FEATURES_LIST, SKILL_LIST } from './index.js';
import Skill from '@/components/Skill';
import Function from './components/Function';
import Cases from './components/Cases';
export default {
  components: {
    Banner,
    Appointment2,
    Features,
    Function,
    Skill,
    Cases
  },
  data() {
    return {
      featuresList: FEATURES_LIST,
      skillList: SKILL_LIST,
      productId: this.$productId.YUN_YING_GONG_JU.HUO_DONG_YUN_YING_PING_TAI
    };
  }
};